<template>
    <div class="basicData" v-wechat-title="$t('网络需求单管理')">
        <Title :title="$t('网络需求单管理')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('客户名称') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.clientName" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('联系人') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.contact" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('设备编号') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.mtSn" clearable maxlength="15"></el-input>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('报修单号') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.faultReportSn" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('网单类型') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.source" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in netRequirementType"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('网单状态') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.status" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in netRequirementStatus"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('创建日期') }}</span></div>
                    <div class="input_box">
                        <el-date-picker v-model="parameters.parameters.createTimeFrom" type="date" :placeholder="$t('开始日期')" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span style="margin-right: 90px;">~</span></div>
                    <div class="input_box">
                        <el-date-picker v-model="parameters.parameters.createTimeTo" type="date" :placeholder="$t('结束日期')" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('服务区域') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.areaId" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in organizationList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn_box">
            <button type="button" class="search_btn" @click="search">{{ $t('查询') }}</button>
        </div>
        <div class="common_title manage_net_list detail_title">{{ $t('网单列表总数') +  pageInfo1.total }}</div>
        <div class="table_box">
            <el-table :data="manageNetList" v-loading="loading1" height="440">
                <el-table-column :label="$t('网单号')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.sn || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('网单类型')" align="center">
                    <template slot-scope="scope">
                        {{ ChangeNetRequirementType(scope.row.source) || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('创建日期')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.creationTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('客户名称')" align="center">
                    <template slot-scope="scope">
                        <span :title="scope.row.clientName">{{ scope.row.clientName || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('网单状态')" align="center">
                    <template slot-scope="scope">
                        {{ ChangeNetNetRequirementStatus(scope.row.status) || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" align="center" width="150">
                    <template slot-scope="scope">
                        <div class="table_btn_box">
                            <button class="table_btn edit" :title="$t('编辑')" @click.stop="edit(scope.row)"></button>
                            <button class="table_btn icon_merge_order" :title="scope.row.status !== 1 ? $t('不可并单') : $t('并单')" v-permissions="210307" @click.stop="mergeSheet(scope.row)" :disabled="scope.row.status !== 1"></button>
                            <button class="table_btn cancel" :title="scope.row.status !== 1 ? $t('不可撤销') : $t('撤销')" v-permissions="210305" @click.stop="cancel(scope.row)" :disabled="scope.row.status !== 1"></button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination_box">
                <el-pagination
                        @current-change="handleCurrentChange1"
                        :current-page="page1"
                        layout="total, prev, pager, next, jumper"
                        :total="pageInfo1.total">
                </el-pagination>
            </div>
        </div>
        <div class="common_title manage_net_list detail_title">{{ $t('未派工需求列表') }}</div>
        <div class="table_box">
            <el-table :data="demandList" v-loading="loading2" height="440">
                <el-table-column :label="$t('需求单号')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.sn || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('创建日期')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.creationTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('客户名称')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.clientName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" align="center" width="150">
                    <template slot-scope="scope">
                        <div class="table_btn_box">
                            <button class="table_btn edit" :title="$t('编辑')" @click.stop="requirementDetail(scope.row)"></button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination_box">
                <el-pagination
                        @current-change="handleCurrentChange2"
                        :current-page="page2"
                        layout="total, prev, pager, next, jumper"
                        :total="pageInfo2.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import formatDate from '../../plugins/formatDate'
    export default {
        name: 'keep-alive',
        data () {
            return {
                loading1: false,
                loading2: false,
                manageNetList: [],
                demandList: [],
                pageInfo1: {
                  total: 0
                },
                pageInfo2: {
                    total: 0
                },
                page1: 1,
                page2: 1,
                parameters: {
                    page: 1,
                    rows: 10,
                    parameters: {
                        areaId: '',
                        clientName: '',
                        contact: '',
                        createTimeFrom: formatDate.timeToString(new Date().getTime() - 3600 * 1000 * 24 * 31),
                        createTimeTo: formatDate.timeToString(new Date().getTime()),
                        mtSn: '',
                        source: '',
                        status: '',
                        faultReportSn: ''
                    }
                },
                netRequirementType: [
                    {id: 1, name: '机头'},
                    {id: 2, name: '微信'},
                    // {id: 3, name: "工程师扫码报修"},
                    {id: 4, name: 'APP代报修'},
                    {id: 6, name: 'WIS'},
                    {id: 9, name: 'BOX'}
                ],
                netRequirementStatus: [
                    {id: 1, name: '未处理'},
                    {id: 2, name: '已并单'},
                    {id: 3, name: '已生成需求单'},
                    {id: 4, name: '已撤销'}
                ],
                organizationList: []
            }
        },
        mounted () {
            this.initMounted()
        },
        activated () {
            this.getList()
        },
        methods: {
            initMounted () {
                this.netRequirementType = [
                    {id: 1, name: this.$t('机头')},
                    {id: 2, name: this.$t('微信')},
                    {id: 4, name: this.$t('APP代报修')},
                    {id: 6, name: this.$t('WIS')},
                    {id: 9, name: this.$t('BOX')}
                ]
                this.netRequirementStatus = [
                    {id: 1, name: this.$t('未处理')},
                    {id: 2, name: this.$t('已并单')},
                    {id: 3, name: this.$t('已生成需求单')},
                    {id: 4, name: this.$t('已撤销')}
                ]
                this.getOrganizationList()
                this.search()
            },
            handleCurrentChange1 (val) {
                let parameters = JSON.parse(JSON.stringify(this.parameters))
                parameters.page = this.page1 = val
                this.getNetworkLists(parameters)
            },
            handleCurrentChange2 (val) {
                let parameters = JSON.parse(JSON.stringify(this.parameters))
                parameters.page = this.page2 = val
                this.getRequirementGetList(parameters)
            },
            search () {
                this.page1 = this.page2 = 1
                this.getList()
            },
            getList () {
                let parameters = JSON.parse(JSON.stringify(this.parameters))
                this.getNetworkLists(parameters)
                this.getRequirementGetList(parameters)
            },
            mergeSheet (item) {
                this.$prompt(this.$t('该网单合并至另一需求单号'), this.$t('并单'), {
                    confirmButtonText: this.$t('确定'),
                    confirmButtonClass: 'save__btn',
                    cancelButtonText: this.$t('取消'),
                    cancelButtonClass: 'back__btn',
                    type: 'warning',
                    center: true,
                    showClose: false,
                    inputPattern: /\S/,
                    inputErrorMessage: this.$t('请输入')
                }).then(({ value }) => {
                    this.$store.dispatch('a:manageNetList/merge', {id: item.id, requirementSn: value}).then(
                        () => {
                            this.$message.success(this.$t('保存成功'))
                            let parameters = JSON.parse(JSON.stringify(this.parameters))
                            parameters.page = this.page1
                            this.getNetworkLists(parameters)
                        },
                        rej => {
                            this.$message.error(rej.errorInfo);
                        }
                    )
                }).catch(() => {

                });
            },
            cancel (item) {
                this.$confirm(this.$t('撤销后无法恢复，确认撤销该条记录？'), this.$t('提示'), {
                    confirmButtonText: this.$t('确定'),
                    confirmButtonClass: 'save__btn',
                    cancelButtonText: this.$t('取消'),
                    cancelButtonClass: 'back__btn',
                    type: 'warning',
                    center: true,
                    showClose: false
                }).then(() => {
                    this.$store.dispatch('a:manageNetList/cancel', {netRequirementId: item.id}).then(
                        () => {
                            this.$message.success(this.$t('撤销成功！'))
                            let parameters = JSON.parse(JSON.stringify(this.parameters))
                            parameters.page = this.page1
                            this.getNetworkLists(parameters)
                        },
                        rej => {
                            this.$message.error(rej.errorInfo);
                        }
                    )
                }).catch(() => {

                });
            },
            edit (item) {
                this.$router.push({
                    path: '/manageNetListDetail',
                    query: {
                        id: item.id
                    }
                })
            },
            requirementDetail (item) {
                this.$router.push({
                    path: '/requirementDetail',
                    query: {
                        id: item.id
                    }
                })
            },
            getNetworkLists (parameters) {
                this.loading1 = true
                this.$store.dispatch('a:manageNetList/netRequirementGetList', parameters).then(
                    res => {
                        this.manageNetList = res.list || []
                        this.loading1 = false
                        this.pageInfo1 = res.pageInfo
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                        this.loading1 = false
                    }
                )
            },
            getRequirementGetList (parameters) {
                parameters.parameters.requirementStatus = 1
                this.loading2 = true
                this.$store.dispatch('a:manageNetList/requirementGetList', parameters).then(
                    res => {
                        this.demandList = res.list || []
                        this.loading2 = false
                        this.pageInfo2 = res.pageInfo
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                        this.loading2 = false
                    }
                )
            },
            getOrganizationList () {
                this.$store.dispatch('a:common/getOrganizationList', {level: 3}).then(
                    res => {
                        this.organizationList = res || []
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
